"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllStringsFromObject = void 0;
// Used to get all the routes as list of strings from the routes object
// Object may only contain string values or other objects containing strings or other objects etc.
var getAllStringsFromObject = function (obj) {
    if (typeof obj === 'string') {
        return [obj];
    }
    else {
        return Object.values(obj).flatMap(function (o) {
            return __spreadArray([], (0, exports.getAllStringsFromObject)(o), true);
        });
    }
};
exports.getAllStringsFromObject = getAllStringsFromObject;
